// Packages
import { Fragment } from "react";

// Components
import TextField from "./custom_fields/TextField";
import SelectField from "./custom_fields/SelectField";
import CheckboxField from "./custom_fields/CheckboxField";
import InputField from "./custom_fields/InputField";
import DateField from "./custom_fields/DateField";

function CustomFieldList({
  customFields,
  errors,
  setCustomField,
  custom,
  locale,
  PhoneNumber = null,
  AcceptsMarketing = null,
  TaxId = null,
  AdditionalInformation = null,
}) {
  const sortedCustomFields = [...customFields].sort(
    (a, b) => a.position - b.position,
  );

  return (
    <Fragment>
      {sortedCustomFields.map((customField, index) => {
        switch (customField.type) {
          case "additional_information":
            return AdditionalInformation ? AdditionalInformation : null;
          case "taxid":
            return TaxId ? TaxId : null;
          case "accepts_marketing":
            return AcceptsMarketing ? AcceptsMarketing(customField) : null;
          case "phone":
            return PhoneNumber ? PhoneNumber() : null;
          case "text":
            return (
              <TextField
                key={`text-${index}`}
                {...customField}
                errors={errors}
                setCustomField={setCustomField}
                custom={custom}
              />
            );
          case "selection":
            return (
              <SelectField
                key={`select-${index}`}
                {...customField}
                errors={errors}
                setCustomField={setCustomField}
                custom={custom}
              />
            );
          case "input":
            return (
              <InputField
                key={`input-${index}`}
                {...customField}
                errors={errors}
                setCustomField={setCustomField}
                custom={custom}
              />
            );
          case "checkbox":
            return (
              <CheckboxField
                key={`checkbox-${index}`}
                {...customField}
                errors={errors}
                setCustomField={setCustomField}
                custom={custom}
              />
            );
          case "date":
            return (
              <DateField
                key={`date-${index}`}
                {...customField}
                errors={errors}
                setCustomField={setCustomField}
                custom={custom}
                locale={locale}
              />
            );
        }
      })}
    </Fragment>
  );
}

export default CustomFieldList;
